export function isInExtendedReturnsWindow() {
  // start date is 26 September 2023 at 00:00:00 UK time
  // deadline date is 24 December 2023 at 23:59:59 UK time
  // (Note that these are the UTC equivalents, and remember: month index is zero-based)
  const startDateUtc = Date.UTC(2023, 8, 26, 23, 0, 0);
  const deadlineDateUtc = Date.UTC(2023, 11, 24, 23, 59, 59);

  const currentDate = Date.now();

  const showExtendedReturnsMessage =
    currentDate < deadlineDateUtc && currentDate >= startDateUtc;
  return showExtendedReturnsMessage;
}
